<script type="ts">
	export let value: Date;
	export let placeholder = 'Fecha';

	let day;
	let month;
	let year;

	function limitLength(e: any, length: number) {
		if (e.target.value.length > length) {
			e.target.value = e.target.value.slice(0, length);
		}
	}

	const validate = () => {
		if (day && month && year) {
			value = new Date(year, month - 1, day);
		}
	};
</script>

<div>
	<label for="inputDate" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
		>{placeholder}</label
	>
	<div class="flex items-center w-full">
		<input
			type="number"
			class="text-sm w-1/4 px-4 py-3 flex-grow border border-gray-200 rounded-lg focus:border-blue-300  appearance-none hover:appearance-none focus:appearance-none "
			placeholder="DD"
			min="1"
			max="31"
			bind:value={day}
			on:input={(e) => limitLength(e, 2)}
			on:blur={() => validate()}
		/>
		<span class="px-2"> - </span>
		<input
			type="number"
			class=" text-sm  w-1/4 px-4 py-3 flex-grow border border-gray-200 rounded-lg focus:border-blue-300  appearance-none hover:appearance-none focus:appearance-none "
			placeholder="MM"
			min="1"
			max="12"
			maxlength="2"
			bind:value={month}
			on:input={(e) => limitLength(e, 2)}
			on:blur={() => validate()}
		/>
		<span class="px-2"> - </span>

		<input
			type="number"
			class=" text-sm w-2/4 px-4 py-3 flex-grow border border-gray-200 rounded-lg focus:border-blue-300   appearance-none hover:appearance-none focus:appearance-none "
			placeholder="YYYY"
			min="1900"
			max="2021"
			maxlength="4"
			bind:value={year}
			on:input={(e) => limitLength(e, 4)}
			on:blur={() => validate()}
		/>
	</div>
</div>
